// extracted by mini-css-extract-plugin
export default {"input":"SelectMenteePage_input__0HLO4","tappable":"SelectMenteePage_tappable__mmE7W"};